<template>
    <nav class="navbar navbar-dark navbar-expand px-lg-1">
        <button data-toggle="collapse" data-target=".sidebar-collapse" class="navbar-brand p-0 btn btn-link">
            <span class="h4 align-middle mb-0"><span class="lnr lnr-menu"></span></span>
        </button>
        <a class="navbar-brand" href="#" title="Home" data-toggle="dropdown">Forque Vue</a>
        <div class="dropdown-menu text-uppercase mt-n1 animate-grow-in">
            <a class="dropdown-item px-3" href="../" target="_new">Home</a>
            <a class="dropdown-item px-3" href="../static" target="_new">jQuery version</a>
            <a class="dropdown-item px-3" href="../react" target="_new">React version</a>
            <a class="dropdown-item px-3 active" href="../vue" target="_new">Vue version</a>
        </div>
        <ul class="navbar-nav ml-auto">
            <li class="nav-item dropdown">
                <button class="nav-link btn btn-link p-0 text-truncate" data-toggle="dropdown">
                    <span class="align-middle" data-toggle="tooltip" data-placement="left" title="You are logged in as Robojo">
                        Robojo
                    </span>
                    <img alt="avatar" src="assets/m20.jpg" class="avatar m-1 ml-0 rounded-circle bg-white shadow-sm" />
                </button>
                <div class="dropdown-menu dropdown-menu-right mt-1 text-uppercase" aria-labelledby="dropdownMenu1">
                    <a class="dropdown-item px-3" href="#" @click="showProfile()"><span class="lnr lnr-user"></span> Profile</a>
                    <router-link class="dropdown-item px-3" :to="'/inbox'">
                        <span class="lnr lnr-inbox"></span> Inbox <span class="badge badge-primary badge-pill font-weight-light align-middle mb-1 p-1" title="notify count"><span>3</span></span>
                    </router-link>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item px-3" href="#" @click="showLogout()"><span class="lnr lnr-exit"></span> Logout</a>
                    <a class="dropdown-item px-3 font-weight-bold" href="http://themes.guide" target="_new" rel="nofollow">About Forque</a>
                </div>
            </li>
        </ul>
        <ModalProfile ref="modalProfile" />
        <ModalLogout ref="modalLogout" />
    </nav>
</template>
<script>
import ModalProfile from "./ModalProfile";
import ModalLogout from "./ModalLogout";

export default {
    components: {
        ModalProfile,
        ModalLogout
    },
    methods: {
        showProfile() {
            this.$refs.modalProfile.show();
        },
        showLogout() {
            this.$refs.modalLogout.show();
        }
    }
};
</script>
